.liste {
  list-style-type: none;
  margin-block: 0;
  margin-inline: 0;
  padding-inline-start: 0;
}
